import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const MovieReelIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7095 6.05123C9.1924 6.05123 4.71871 10.5249 4.71871 16.0421C4.71871 21.559 9.19226 26.0316 14.7095 26.0316C20.2268 26.0316 24.7004 21.559 24.7004 16.0421C24.7004 10.5249 20.2267 6.05123 14.7095 6.05123ZM2.87256 16.0421C2.87256 9.50531 8.17279 4.20508 14.7095 4.20508C21.2464 4.20508 26.5466 9.50531 26.5466 16.0421C26.5466 22.579 21.2461 27.8778 14.7095 27.8778C8.17293 27.8778 2.87256 22.579 2.87256 16.0421Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7097 20.3208C14.2292 20.3208 13.8389 20.7109 13.8389 21.1915C13.8389 21.672 14.2292 22.0622 14.7097 22.0622C15.1903 22.0622 15.5804 21.672 15.5804 21.1915C15.5804 20.7109 15.1903 20.3208 14.7097 20.3208ZM11.9928 21.1915C11.9928 19.6913 13.2096 18.4746 14.7097 18.4746C16.2099 18.4746 17.4266 19.6913 17.4266 21.1915C17.4266 22.6916 16.2099 23.9083 14.7097 23.9083C13.2096 23.9083 11.9928 22.6916 11.9928 21.1915Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5631 15.1714C9.08218 15.1714 8.69235 15.5608 8.69235 16.0422C8.69235 16.5226 9.08259 16.9129 9.5631 16.9129C10.0436 16.9129 10.4339 16.5226 10.4339 16.0422C10.4339 15.5608 10.044 15.1714 9.5631 15.1714ZM6.84619 16.0422C6.84619 14.5404 8.06339 13.3252 9.5631 13.3252C11.0628 13.3252 12.28 14.5404 12.28 16.0422C12.28 17.5422 11.0632 18.7591 9.5631 18.7591C8.06298 18.7591 6.84619 17.5422 6.84619 16.0422Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7097 10.0229C14.2288 10.0229 13.8389 10.4124 13.8389 10.8937C13.8389 11.3742 14.2292 11.7644 14.7097 11.7644C15.1903 11.7644 15.5804 11.3742 15.5804 10.8937C15.5804 10.4124 15.1907 10.0229 14.7097 10.0229ZM11.9928 10.8937C11.9928 9.39195 13.21 8.17676 14.7097 8.17676C16.2095 8.17676 17.4266 9.39195 17.4266 10.8937C17.4266 12.3938 16.2099 13.6106 14.7097 13.6106C13.2096 13.6106 11.9928 12.3938 11.9928 10.8937Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8563 15.1714C19.3753 15.1714 18.9856 15.5608 18.9856 16.0422C18.9856 16.5226 19.3758 16.9129 19.8563 16.9129C20.3368 16.9129 20.7271 16.5226 20.7271 16.0422C20.7271 15.5608 20.3372 15.1714 19.8563 15.1714ZM17.1394 16.0422C17.1394 14.5404 18.3566 13.3252 19.8563 13.3252C21.356 13.3252 22.5732 14.5404 22.5732 16.0422C22.5732 17.5422 21.3564 18.7591 19.8563 18.7591C18.3561 18.7591 17.1394 17.5422 17.1394 16.0422Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7861 26.9553C13.7861 26.4455 14.1994 26.0322 14.7092 26.0322L25.9491 26.0322C26.4589 26.0322 26.8722 26.4455 26.8722 26.9553C26.8722 27.4652 26.4589 27.8784 25.9491 27.8784L14.7092 27.8784C14.1994 27.8784 13.7861 27.4651 13.7861 26.9553Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default MovieReelIcon;
